module.exports = __webpack_public_path__ + "img/KSC06172.b6737775.jpg";